import module from '../module';
import * as _ from 'lodash';
import moment from 'moment';

export class FooterDirectiveController {
    static $inject = ['$scope', 'ConfigurationService', 'cartonomyConfig'];

    constructor($scope, configurationService, cartonomyConfig) {

        $scope.addresses = [];
        $scope.hours = [];
        $scope.externalStoreMode = cartonomyConfig.externalStoreMode;
        $scope.currentYear = new Date().getFullYear();

        configurationService.getItem('addresses').then(function (addresses) {
            $scope.addresses = addresses;
        });

        configurationService.getItem('storeHours').then(function (hours) {

            _.each(hours, function (hour) {
                hour.open = hour.open ? moment(hour.open).format('LT') : '';
                hour.close = hour.close ? moment(hour.close).format('LT') : '';
            });

            $scope.hours = hours;
        });
    }
}

module.directive('cartonomyFooter', function () {
    return {
        template: require('../views/footer.pug'),
        controller: FooterDirectiveController
    };
});



// WEBPACK FOOTER //
// ./src/modules/shared/directives/FooterDirective.js